import SelectColumnFilter from "./SelectColumnFilter";
import { truncateWords } from "../../../utils/helpers";
import moment from "moment";
import Eye from "../../../components/Eye/Eye";
import { ButtonSpan } from "../dashboard/home/home.style";

const renderToolTipContent = (list: any) => {
  if (Array.isArray(list) && list.length > 1) {
    return [...list.filter((item: any) => list.indexOf(item) !== 0)]
      .map(
        (item, i) =>
          `<div key={i} style="margin-bottom:10px;">
            ${item}
          </div>`
      )
      .join(" ");
  } else {
    return `<div key={i} style="margin-bottom:10px;">
        ${list}
      </div>`;
  }
};

export const COLUMNS = [
  {
    Header: "User",
    accessor: "userFullname",
    Cell: ({ value }: any) => {
      return value.length > 15 ? (
        <ButtonSpan
          data-tooltip-id="my-tooltip"
          data-tooltip-html={`<div>${renderToolTipContent(value)}</div>`}
        >
          {truncateWords(value)}
        </ButtonSpan>
      ) : (
        value
      );
    },
    Filter: SelectColumnFilter,
    disableFilters: true,
  },
  {
    Header: "Username",
    accessor: "UserName",
    Cell: ({ value }: any) => {
      return value?.length > 15 ? (
        <ButtonSpan
          data-tooltip-id="my-tooltip"
          data-tooltip-html={`<div>${renderToolTipContent(value)}</div>`}
        >
          {truncateWords(value)}
        </ButtonSpan>
      ) : (
        truncateWords(value)
      );
    },
    Filter: SelectColumnFilter,
    disableFilters: true,
  },
  {
    Header: "Role",
    accessor: "userRoleName",
    Cell: ({ value }: any) => {
      return value?.length > 15 ? (
        <ButtonSpan
          data-tooltip-id="my-tooltip"
          data-tooltip-html={`<div>${renderToolTipContent(value)}</div>`}
        >
          {truncateWords(value)}
        </ButtonSpan>
      ) : (
        value || ""
      );
    },
    Filter: SelectColumnFilter,
    filter: "includes",
  },
  {
    Header: "Facility",
    accessor: "Facilities",
    Cell: (value: any) => {
      return (
        <ButtonSpan
          data-tooltip-id="my-tooltip"
          data-tooltip-html={`<div>${renderToolTipContent(
            value.cell.row.original.facilityList
          )}</div>`}
        >
          {truncateWords(value.cell.row.original.facilityList)}
        </ButtonSpan>
      );
    },
    Filter: SelectColumnFilter,
  },
  {
    Header: "Start Date",
    accessor: "CreatedDate",
    Cell: ({ value }: any) => moment(value).format("DD MMM YYYY"),
    Filter: SelectColumnFilter,
    disableFilters: true,
  },
  {
    Header: "Last Active",
    accessor: "lastLoginDate",
    Cell: ({ value }: any) =>
      value ? moment(value).format("DD MMM YYYY") : "-",
    Filter: SelectColumnFilter,
    disableFilters: true,
  },
  {
    Header: "Action",
    accessor: "",
    Cell: (item: any) => {
      return (
        <Eye
          testId={`view-user-btn-${item.row.id}-${item.cell.column.id}`}
          id="view-user-btn"
          cb={item.cb}
          row={item.row}
        />
      );
    },
    Filter: SelectColumnFilter,
    disableFilters: true,
  },
];
